import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import "../header.css";

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
        element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMenuOpen(false);
    };

    return (
        <header className="header">
            <div className="header-container">
            <div className="header-content">
            <div className="header-logo">
            <h1 className="header-title">
                <span className="brand-accent">OIG</span>Hosting
            </h1>
            </div>

          {/* Desktop Navigation */}
            <nav className="nav-desktop">
            <button
                onClick={() => scrollToSection("hero")}
                className="nav-button"
            >
                Home
            </button>
            <button
                onClick={() => scrollToSection("website-packages")}
                className="nav-button"
            >
                Website Packages
            </button>
            <button
                onClick={() => scrollToSection("hosting-plans")}
                className="nav-button"
            >
                Hosting Plans
            </button>
            <button
                onClick={() => scrollToSection("contact")}
                className="nav-button"
            >
                Contact
            </button>
            </nav>

            <div className="header-cta">
            <button
                onClick={() => scrollToSection("contact")}
                className="cta-button"
            >
                Get Started
            </button>
            </div>

          {/* Mobile menu button */}
            <div className="mobile-menu-button">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)}>
                {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
            </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
            <div className="nav-mobile">
            <div className="nav-mobile-content">
                <button
                onClick={() => scrollToSection("hero")}
                className="nav-mobile-button"
                >
                Home
                </button>
                <button
                onClick={() => scrollToSection("website-packages")}
                className="nav-mobile-button"
                >
                Website Packages
                </button>
                <button
                onClick={() => scrollToSection("hosting-plans")}
                className="nav-mobile-button"
                >
                Hosting Plans
                </button>
                <button
                onClick={() => scrollToSection("contact")}
                className="nav-mobile-button"
                >
                Contact
                </button>
                <button
                onClick={() => scrollToSection("contact")}
                className="mobile-cta-button"
                >
                Get Started
                </button>
            </div>
            </div>
        )}
        </div>
    </header>
    );
};

export default Header;
